<template>
  <v-dialog v-model="dialog" width="90%">

    <v-card elevation="3">
      <div class="pp-sidenav">
        <v-card-title class="white--text">
          Edit a Review
        </v-card-title>

        <v-card-subtitle class="white--text">
          Amend details below
        </v-card-subtitle>
      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <v-tabs
          dark
          width="250"
          color="primary"
          vertical
      >
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-pencil
          </v-icon>
          Edit a review
        </v-tab>

        <v-tab-item>
          <v-card flat v-if="currentReviewItem">
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Edit <span class="primary--text ml-2"> {{ currentReviewItem.title }} </span>
                    <v-icon class="ml-1">mdi-chevron-right</v-icon>
                  </v-card-title>

                  <v-card-text>
                    <div class="py-10 px-2">
                      <v-row>
                        <v-text-field
                            v-model="editableReviewItem.title"
                            label="Edit Category Name"
                            aria-required="true"
                            color="primary"
                            placeholder="Edit Category Name"
                            prepend-icon="mdi-file-edit-outline"
                            flat
                            solo
                            clearable>
                        </v-text-field>
                      </v-row>

                      <v-row v-if="reviewApiError && reviewApiError.fields && reviewAddError.fields.title" class="err-text">
                        <p class="error--text">
                          Review title should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <v-row class="mb-5">
                        <v-text-field
                            v-model="editableReviewItem.author"
                            hint="The author will be publicly visible"
                            persistent-hint
                            label="Author"
                            aria-required="true"
                            color="primary"
                            placeholder="Edit Category Description"
                            prepend-icon="mdi-account-outline"
                            flat
                            solo
                            clearable
                        ></v-text-field>
                      </v-row>
                      <v-row v-if="reviewApiError && reviewApiError.fields && reviewAddError.fields.author" class="err-text">
                        <p class="error--text">
                          Review author should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <v-row class="mb-5">
                        <v-textarea
                            v-model="editableReviewItem.review"
                            auto-grow
                            hint="The review will be publicly visible"
                            persistent-hint
                            label="Review"
                            aria-required="true"
                            color="primary"
                            placeholder="Edit Category Description"
                            prepend-icon="mdi-format-line-style"
                            flat
                            solo
                            clearable
                        >
                        </v-textarea>
                      </v-row>

                      <v-row v-if="reviewApiError && reviewApiError.fields && reviewApiError.fields.review" class="err-text">
                        <p class="error--text">
                          Review should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <ImagePicker v-model="editableReviewItem.image"/>

                      <TagsInput
                          v-model="editableReviewItem.tags"
                          :validationError="reviewApiError"
                      />

                      <v-row v-if="reviewApiError">
                        <v-alert
                            text
                            color="red"
                            icon="mdi-alert-circle-outline"
                        >
                          There was an error in submission. Please check all fields and try again.
                        </v-alert>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </template>
            </v-container>
          </v-card>
          <div v-else>
            <UnavailableContent />
          </div>
        </v-tab-item>
      </v-tabs>

      <!-- ------------------------------------------ buttons ------------------------------------------ -->
      <div class="pp-sidenav">
        <div class="btm">
          <Loading v-if="reviewItemLoading"/>
          <ConfirmCancelButtons
              :item="currentReviewItem"
              :confirm-disabled="reviewItemLoading"
              :confirm-action="editItemConfirm"
              :cancel-action="closeDialog"
              confirm-text="Save Changes"/>
        </div>
      </div>
      <!-- ------------------------------------------end of buttons ------------------------------------------ -->
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from "@/components/common/Loading";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import { mapActions, mapGetters } from "vuex";
import UnavailableContent from "@/components/common/UnavailableContent";
import ImagePicker from "@/components/common/ImagePicker";
import TagsInput from "@/components/common/TagsInput";

export default {
  name: "ReviewEdit",
  components: {TagsInput, UnavailableContent, Loading, ConfirmCancelButtons, ImagePicker},
  computed: {
    ...mapGetters([
      'reviewApiError', 'openDialog', 'currentReviewItem', 'editableReviewItem', 'reviewItemLoading',
    ]),
    dialog: {
      get () {
        return this.openDialog === 'reviewEdit';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['editReview', 'clearReviewItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearReviewItems();
    },
    async editItemConfirm() {
      const edited = await this.editReview(this.editableReviewItem);

      if (edited) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
